import { getTitleConfig } from '../../lib/credits';

interface TitleBadgeProps {
  slug: string | null;
  size?: 'sm' | 'lg';
}

export function TitleBadge({ slug, size = 'sm' }: TitleBadgeProps) {
  const config = getTitleConfig(slug);
  if (!config) return null;

  if (size === 'lg') {
    return (
      <span className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r ${config.badgeClass} shadow-lg font-bold text-sm tracking-wide`}>
        <span className="text-base">{config.emoji}</span>
        <span>{config.label}</span>
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-gradient-to-r ${config.badgeClass} shadow-md font-bold text-[11px] tracking-wide border border-white/20`}>
      <span>{config.emoji}</span>
      <span>{config.label}</span>
    </span>
  );
}
